import { GAEvent } from './events'

export const sendEvent = (event: GAEvent, params: Record<string, string>) => {
  if (typeof window !== 'undefined') {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, params)
    }
  }
}
